import { Api_GPS, ApiActiveStatus, ApiGPSArea, ApiItemTypes, ApiQueryTargetType, ApiSearchRequest, ApiSearchRequest2, ApiStatusRequest, GenericHttpResult } from '@agunity/api-v4';
import { apiService } from '../../api/apiService';

export const activateDeactivateMembers =
  (itemType: ApiItemTypes, activeStatus: ApiActiveStatus, data: ApiStatusRequest) =>
    async () => {
      const response = await apiService.uiV10ActiveStatusPartialUpdate2(itemType, activeStatus, data);
      return response;
    };

export const createBindCodes =
  (data: number[]) =>
    async () => {
      const response = await apiService.bindingV10CreateBindCodesCreate(data);
      return response;
    };
    
export const sendEmail =
  (data: ApiSearchRequest2) =>
    async () => {
      const response = await apiService.searchV10EmailCreate(data);
      return response;
    };

export const getSearchResult =
  (data: ApiSearchRequest) =>
    async () => {
      const response = await apiService.searchV10SearchCreate(data);
      return response;
    };

export const getSearchResultList =
  (data: ApiSearchRequest2) =>
    async () => {
      const response = await apiService.searchV11ListCreate(data);
      return response;
    };

export const getSystemUnits =
  () =>
    async () => {
      const response = await apiService.systemV10UnitsList();
      return response;
    };

export const getSystemEnums =
  () =>
    async () => {
      const response = await apiService.systemV10EnumsList();
      return response;
    };

export const getSearchColumns =
  (template: ApiQueryTargetType) =>
    async () => {
      const response = await apiService.searchV10ProfileDetail(template);
      return response;
    };

export const changeStatus =
  (itemType: ApiItemTypes, itemId: number, activeStatus: ApiActiveStatus) =>
    async () => {
      const response = await apiService.uiV10ActiveStatusPartialUpdate(itemType, itemId, activeStatus);
      return response;
    };

export const getUsers =
  (orgId: number) =>
    async (
    ) => {
      const response = await apiService.organizationV11PermissionedUsersDetail(orgId, 57);
      return response;
    };

export const saveManager =
  (orgId: number, ownerId: number) =>
    async (
    ) => {
      const response = await apiService.organizationV10OwnerPartialUpdate(orgId, ownerId);
      return response;
    };

export const getTagList =
  () =>
    async (
    ) => {
      const response = await apiService.tagV10ListList();
      return response;
    };

export const addToTagList =
  (itemType: ApiItemTypes, itemId: number) =>
    async (
    ) => {
      const response = await apiService.tagV10ItemCreate(itemType, itemId);
      return response;
    };

export const deleteFromTagList =
  (itemType: ApiItemTypes, itemId: number) =>
    async () => {
      const response = await apiService.tagV10ItemDelete(itemType, itemId);
      return response;
    };

export const getPlotChildGPS = (orgId: number) => {
  return async (): Promise<GenericHttpResult<Api_GPS[]>> => {
    const response = await apiService.plotV10SetChildGpsDetail(orgId);
    return response;
  };
};

export const getPlotChildPolygons = (orgId: number) => {
  return async (): Promise<GenericHttpResult<ApiGPSArea[]>> => {
    const response = await apiService.plotV10SetChildPolygonDetail(orgId);
    return response;
  };
};

export const unbindSoft = (identityId: number) => {
  return async (): Promise<GenericHttpResult<void>> => {
    const response = await apiService.bindingV20UnbindSoftCreate(identityId);
    return response;
  };
};

export const unbindHard = (identityId: number) => {
  return async (): Promise<GenericHttpResult<void>> => {
    const response = await apiService.bindingV20UnbindHardCreate(identityId);
    return response;
  };
};

export const getBindingToken = (identityId: number) => {
  return async (): Promise<GenericHttpResult<string>> => {
    const response = await apiService.bindingV20BindingTokenDetail(identityId);
    return response;
  };
};